import { render } from "./DropdownHelp.vue?vue&type=template&id=3381c4ea"
import script from "./DropdownHelp.vue?vue&type=script&lang=js"
export * from "./DropdownHelp.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cargo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__